import type { SVGProps } from 'react';

const SvgStampEmoji = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height={48}
    viewBox='0 0 55 48'
    width={55}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <circle cx={22.4} cy={22.4} fill='#FFC84D' r={22.4} transform='matrix(-1 0 0 1 52.622 1.6)' />
    <path
      d='M39.886 17.996c-.25-1.597.17-2.989.938-3.11.769-.12 1.595 1.077 1.845 2.674s-.17 2.989-.938 3.109c-.769.12-1.594-1.076-1.845-2.673M34.157 19c-.25-1.596.17-2.988.939-3.109.768-.12 1.594 1.077 1.844 2.673s-.17 2.99-.938 3.11c-.769.12-1.594-1.077-1.845-2.673'
      fill='#111'
    />
    <rect
      fill='#C7C7C7'
      height={2.612}
      rx={1.306}
      transform='matrix(-1 0 0 1 23.12 43.788)'
      width={19.588}
    />
    <path
      d='M21.16 43.185a5.926 5.926 0 0 0-5.926-5.926h-3.818a5.926 5.926 0 0 0-5.926 5.926v.603h15.67z'
      fill='#FF74B3'
    />
    <path
      clipRule='evenodd'
      d='M10.702 22.152a4.57 4.57 0 1 1 6.941-3.909c0 1.656-.88 3.106-2.2 3.908-.26 1.322-.412 2.893-.412 4.58 0 4.679 1.165 8.473 2.603 8.489H8.512c1.438-.016 2.602-3.81 2.602-8.489 0-1.687-.15-3.258-.412-4.58'
      fill='#FF74B3'
      fillRule='evenodd'
    />
  </svg>
);
export default SvgStampEmoji;
